module.exports = __webpack_public_path__ + "img/bg03.8df1a108.png";